/* src/app/modules/institutions/institutions-additional-data/institutions-additional-data.component.scss */
#additional-data ::ng-deep .cw-grid-container {
  overflow: auto;
}
/*# sourceMappingURL=institutions-additional-data.component.css.map */
